import classes from './PlantsSummary.module.css';

const PlantsSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Beautiful Plants, Delivered To You </h2>
      <p>
        Choose your favorite plants from our broad selection of available plants.
      </p>
      <p>
      We are here to inspire a world where every plant journey is a personal revolution of inner change and growth.

      </p>
    </section>
  );
};

export default PlantsSummary;